module.exports = __webpack_public_path__ + "img/banner_left.3283a8f4.png";